import * as React from 'react';
import SearchInput from "./SearchInput";
import styles from "./table.module.scss";
import { Button, Flex } from "@mantine/core";
import ScrollControl from "../common/ScrollControl";
import { useStyles } from "./useTableStyles";
import { useTable, Column } from "react-table";
import { useTableSort } from "../../hooks";
import { getSortedList } from "../../utils/sort";
import { IconTableExport } from "@tabler/icons-react";
import { utils, writeFileXLSX } from "xlsx";
import dayjs from "dayjs";
// TODO add row virtualization

interface Props {
    data: any[];
    columns: Column<any>[];
}

const NoPaginationTable = ({
    data,
    columns
}: Props) => {

    const { classes } = useStyles();
    const [ searchValue, setSearchValue ] = React.useState('');
    const containerRef = React.useRef<HTMLDivElement>(null);
    const { sort, getSort, setSort } = useTableSort();

    const tableColumns: Column<any>[] = React.useMemo(() => {
        return columns
    }, [ columns ]);

    const tableData = React.useMemo(() => {
        const columnIds = tableColumns.map(c => c.accessor);
        let result: any[] = [];
        if (searchValue) {
            const lowerSearchValue = searchValue.toLowerCase();
            for (const record of data) {
                for (const columnId of columnIds) {
                    if (typeof columnId === 'string') {
                        const value = record[columnId];
                        if (typeof value === 'string') {
                            if (value.toLowerCase().includes(lowerSearchValue)) {
                                result.push(record)
                            }
                        }
                    }
                }
            }
        } else {
            result = data;
        }
        return getSortedList(sort, result);
    }, [ data, searchValue, tableColumns, sort ]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns: tableColumns,
        data: tableData,
        defaultColumn: {
            defaultCanSort: true
        }
    })

    const handleSort = (id: string) => {
        const sortObj = getSort(id);
        setSort(sortObj);
    }

    const downloadExcel = () => {
        // TODO: dynamic

        const array = [];

        // @ts-ignore
        for (const [ index, record ] of tableData.entries()) {
            let apple = '-';
            let google = '-';
            for (const socialAccount of (record.socialAccounts ?? [])) {
                if (socialAccount.platform === 'apple') {
                    apple = socialAccount.reference;
                }
                if (socialAccount.platform === 'google') {
                    google = socialAccount.reference;
                }
            }
            array.push({
                '№': index + 1,
                'Хэрэглэгчийн ID': record.customerId,
                'И-мэйл': record.email,
                'Apple Account': apple,
                'Google Account': google,
                'Утас': record.phoneNumber,
                'Үүссэн огноо': record.createdAt,
            })
        }

        const ws = utils.json_to_sheet(array);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Дуунууд");
        writeFileXLSX(wb, `Апп хэрэглэгч (${searchValue ? searchValue : 'бүгд'}).xlsx`);
    }

    return (
        <div className={classes.wrapper}>
                <div className={classes.header}>
                    <SearchInput onChange={setSearchValue}/>
                    <Button
                        rightIcon={<IconTableExport size={20}/>}
                        onClick={downloadExcel}
                        mr='sm'
                    >
                        Excel татах
                    </Button>
                </div>
            <div className={classes.tableWrapper} ref={containerRef}>
                <table {...getTableProps({ className: styles.table })}>
                    <thead>
                    {// Loop over the header rows
                        headerGroups.map(headerGroup => (
                            // Apply the header row props
                            <tr {...headerGroup.getHeaderGroupProps({ className: classes.headerRow })}>
                                <th className={styles.headerCell}>№</th>
                                {// Loop over the headers in each row 🔽 🔼
                                    headerGroup.headers.map(column => {
                                        let sortText = '';
                                        if (sort?.[column.id] === 1) {
                                            sortText = '🔼'
                                        } else if (sort?.[column.id] === -1) {
                                            sortText = '🔽'
                                        }
                                        return (
                                            // Apply the header cell props
                                            <th
                                                {...column.getHeaderProps({ className: styles.headerCell })}
                                                onClick={() => {
                                                    column.defaultCanSort && handleSort(column.id)
                                                }}
                                            >
                                                {// Render the header
                                                    column.render('Header')
                                                }
                                                {sortText}
                                            </th>
                                        )
                                    })}
                            </tr>
                        ))}
                    </thead>
                    {/* Apply the table body props */}
                    <tbody {...getTableBodyProps({ className: styles.body })}>
                    {// Loop over the table rows
                        rows.map(row => {
                            // Prepare the row for display
                            prepareRow(row)
                            // const orderNumber = pageSize * pageIndex + row.index + 1;
                            return (
                                // Apply the row props
                                <tr {...row.getRowProps({ className: styles.row })}>
                                    <td className={styles.cell}>{row.index + 1}</td>
                                    {// Loop over the rows cells
                                        row.cells.map(cell => {
                                            // console.log('cel?>>>', cell.getCellProps({
                                            //     className:  styles.cell
                                            // }))
                                            // Apply the cell props
                                            return (
                                                <td
                                                    {...cell.getCellProps({
                                                    className:  styles.cell
                                                })}>
                                                    {// Render the cell contents
                                                        cell.render('Cell')}
                                                </td>
                                            )
                                        })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className={classes.paginationWrapper}>
                <Flex gap='xs'>
                    <ScrollControl
                        vertical={containerRef}
                        horizontal={containerRef}
                    />
                </Flex>
            </div>
        </div>
    )
};

export default NoPaginationTable;